const COMMENTS = [
  {
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20friendly%20young%20Chinese%20person%20avatar%20portrait%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-01-2026&orientation=squarish',
    date: '2天前',
    text: '用91影视看片半年了，资源真的全！繁花、庆余年这些热剧更新特别快，画质也很清晰。最赞的是没有广告，比那些弹窗满天飞的软件强太多了。',
    rating: 5,
  },
  {
    name: '电影发烧友老李',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20friendly%20middle%20aged%20Chinese%20man%20avatar%20portrait%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-02-2026&orientation=squarish',
    date: '5天前',
    text: '作为一个电影迷，这个APP满足了我所有需求。新片更新速度快得惊人，周处除三害刚下线这边就能看了，离线下载功能出差坐飞机太实用了。',
    rating: 5,
  },
  {
    name: '学生党小陈',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20friendly%20young%20Chinese%20student%20avatar%20portrait%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-03-2026&orientation=squarish',
    date: '1周前',
    text: '免费这点必须好评！学生党真的负担不起各种VIP，这个APP完全免费而且资源丰富，宿舍WiFi不好就离线缓存，上课路上看太方便了。',
    rating: 5,
  },
  {
    name: '宝妈林女士',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20friendly%20Chinese%20woman%20avatar%20portrait%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-04-2026&orientation=squarish',
    date: '2周前',
    text: '带娃间隙追剧全靠它了！操作简单，分类清晰，找剧很方便。动画片分区孩子也能看，投屏到电视上全家一起看，体验特别好。',
    rating: 4,
  },
  {
    name: '数码控阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20friendly%20young%20Chinese%20tech%20enthusiast%20avatar%20portrait%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-05-2026&orientation=squarish',
    date: '3周前',
    text: '安装包小、不占内存，这点对老手机太友好了。4K画质在旗舰机上效果炸裂，多线路切换也很智能，基本不会遇到卡顿，技术团队用心了。',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            <i className="ri-chat-quote-line mr-1"></i>用户评价
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            影迷真实评价
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            听听使用91影视看片APP的用户怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {COMMENTS.map((comment, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/60 ${i === 0 ? 'lg:col-span-2' : ''}`}
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-foreground-900 text-sm md:text-base">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
                <div className="flex items-center gap-0.5 shrink-0">
                  {[...Array(5)].map((_, starIdx) => (
                    <i
                      key={starIdx}
                      className={`text-sm ${starIdx < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}